/* eslint-disable no-underscore-dangle */
import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { MncFormIOModule as MncFormIOModule } from '@app/mnc-formio.module';
import { environment } from '@env/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(MncFormIOModule, { applicationProviders: [provideZoneChangeDetection()] })
  .catch((err) => console.error(err));
